import styled from '@emotion/styled';
import { Menu } from '@mui/material';

import { theme } from '@/theme';

export const StyledMenu = styled(Menu)`
    .MuiPaper-root {
        border-radius: 0.4rem;
        background-color: ${theme.palette.headings.dark};
    }
`;
